import TeamFormMatchModel from "./TeamFormMatchModel";

export default class TeamFormModel {
  public teamId: string = null;
  public matches: TeamFormMatchModel[] = [];
}
